import { useChangeBrandEsignColorApi } from "brand/api";
import { ColorPicker } from "components";
import React from "react";
import { isDarkColor } from "utilities/colorutils";

interface Props {
  brand: server.dto.Brand
}

const BrandEsignColorPicker = (props: Props) => {
  const [eSignFooterColor, setESignFooterColor] = React.useState(props.brand.eSignFooterBackgroundColor);

  const brandColorApi = useChangeBrandEsignColorApi();

  const onColorChange = async (newColor: string) => {
    setESignFooterColor(newColor);
    await brandColorApi.mutateAsync({
      brandId: props.brand.brandId,
      hexColor: newColor
    });
  };

  return <div>
    <div className="margin-bottom-small">eSign footer</div>
    <ColorPicker
      value={eSignFooterColor}
      onChange={onColorChange}
      trigger={
        <div className="padding-large radius" style={{ backgroundColor: eSignFooterColor, cursor: "pointer", color: isDarkColor(eSignFooterColor) ? "#FFFFFF" : "#000000" }}>
          This color is used in the footer of your eSign documents
        </div>
      }
    />
  </div>;
};

export default BrandEsignColorPicker;